import {
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  GET_ORDERS_REQUEST,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
  UPDATE_ORDER_STATUS_REQUEST,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAILURE,
  PLACE_CUSTOM_ORDER_REQUEST,
  PLACE_CUSTOM_ORDER_SUCCESS,
  PLACE_CUSTOM_ORDER_FAILURE,
  PAYMENT_CALLBACK_REQUEST,
  PAYMENT_CALLBACK_SUCCESS,
  PAYMENT_CALLBACK_FAILURE,
  PAY_ORDER_REQUEST,
  PAY_ORDER_SUCCESS,
  PAY_ORDER_FAILURE,
} from "../actions/ordersActions";

const initialState = {
  orders: [],
  orderStatus: null,
  paymentCallbackStatus: null,
  paymentData: null,
  paymentLoading: false,
  loading: false,
  error: null,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLACE_ORDER_REQUEST:
      return { ...state, loading: true };
    case PLACE_ORDER_SUCCESS:
      return { ...state, loading: false, orderStatus: action.payload };
    case PLACE_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ORDERS_REQUEST:
      return { ...state, loading: true };
    case GET_ORDERS_SUCCESS:
      console.log("Fetched orders payload:", action.payload);
      return { ...state, loading: false, orders: action.payload };
    case GET_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_ORDER_STATUS_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ORDER_STATUS_SUCCESS:
      const updatedOrders = state.orders.map((order) =>
        order.id === action.payload.id ? action.payload : order
      );
      return { ...state, loading: false, orders: updatedOrders };
    case UPDATE_ORDER_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PLACE_CUSTOM_ORDER_REQUEST:
      return { ...state, loading: true };
    case PLACE_CUSTOM_ORDER_SUCCESS:
      return { ...state, loading: false, orderStatus: action.payload };
    case PLACE_CUSTOM_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PAYMENT_CALLBACK_REQUEST:
      return { ...state, loading: true, error: null };
    case PAYMENT_CALLBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentCallbackStatus: action.payload,
      };
    case PAYMENT_CALLBACK_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PAY_ORDER_REQUEST:
      return { ...state, paymentLoading: true, error: null };
    case PAY_ORDER_SUCCESS:
      return {
        ...state,
        paymentLoading: false,
        paymentData: action.payload,
      };
    case PAY_ORDER_FAILURE:
      return { ...state, paymentLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default orderReducer;
